"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _element = _interopRequireDefault(require("./element.js"));
var _cccisdNestedSortable = _interopRequireDefault(require("cccisd-nested-sortable"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var FlowList = /*#__PURE__*/function (_React$Component) {
  _inherits(FlowList, _React$Component);
  var _super = _createSuper(FlowList);
  function FlowList() {
    var _this;
    _classCallCheck(this, FlowList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_onDrop", function (element, parentId, beforeId) {
      if (element.onDrop) {
        var proceed = element.onDrop({
          parentId: parentId,
          beforeId: beforeId,
          // we need to pass it here just to prevent circular dependencies
          verifyAndImportElements: _this.props.verifyAndImportElements
        });
        if (!proceed) {
          return;
        }
      }
      if (element.fromTrash) {
        _this.props.moveElementFromTrash({
          id: element.id,
          parentId: parentId,
          beforeId: beforeId
        });
      } else if (element.id) {
        _this.props.moveElement({
          id: element.id,
          parentId: parentId,
          beforeId: beforeId
        });
      } else {
        _this.props.addElement({
          element: element,
          settings: element.builderInitialValues,
          parentId: parentId,
          beforeId: beforeId
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_getElementType", function (element) {
      var elementType = (0, _find2["default"])(_this.props.elements, {
        code: element.type
      });
      return elementType || {};
    });
    _defineProperty(_assertThisInitialized(_this), "_getTree", function () {
      var currentId = _this.props.currentElement.id;
      var _this$props = _this.props,
        flowSettings = _this$props.flowSettings,
        allQuestionStartNumbers = _this$props.allQuestionStartNumbers;
      var getBranch = function getBranch(element) {
        var result = (0, _pick2["default"])(element, ['id', 'isAdult', 'type', 'isChildAllowed', 'isParentAllowed']);
        if (element.type) {
          var elementType = _this._getElementType(element);
          var initialValues = {
            value: elementType.getPlayerInitialValue(element.settings)
          };
          var extraProps = {};
          if (flowSettings.showQuestionNumbers && allQuestionStartNumbers[element.id]) {
            extraProps.showQuestionNumbers = true;
            extraProps.startQuestionNumber = allQuestionStartNumbers[element.id];
          }
          result.component = /*#__PURE__*/_react["default"].createElement(_element["default"], _extends({
            key: element.id,
            element: element,
            elementType: elementType,
            initialValues: initialValues,
            isCurrent: element.id === currentId,
            isDirty: _this.props.dirtyElements.includes(element.id),
            isRedo: _this.props.redoElements.includes(element.id),
            isNew: _this.props.newElements.includes(element.id),
            viewMode: _this.props.viewMode,
            player: elementType.player,
            changeCurrentElement: _this.props.changeCurrentElement,
            moveElementToTrash: _this.props.moveElementToTrash,
            duplicateElement: _this.props.duplicateElement,
            undoChanges: _this.props.undoChanges,
            redoChanges: _this.props.redoChanges,
            toggleElementPreview: _this.props.toggleElementPreview,
            showRequiredState: flowSettings.showRequiredState,
            dynamicUserLists: _this.props.dynamicUserLists,
            dynamicUserListsValues: _this.props.dynamicUserListsValues,
            defaultValues: _this.props.defaultValues
          }, extraProps));
        }
        if (element.children) {
          result.children = element.children.map(function (child) {
            return getBranch(child);
          });
        }
        return result;
      };
      return getBranch(_this.props.list);
    });
    return _this;
  }
  _createClass(FlowList, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_cccisdNestedSortable["default"], {
        tree: this._getTree(),
        dragDropType: "BUILDER",
        onDrop: this._onDrop
      });
    }
  }]);
  return FlowList;
}(_react["default"].Component);
exports["default"] = FlowList;
_defineProperty(FlowList, "propTypes", {
  elements: _propTypes["default"].array,
  list: _propTypes["default"].object,
  dirtyElements: _propTypes["default"].array,
  redoElements: _propTypes["default"].array,
  newElements: _propTypes["default"].array,
  currentElement: _propTypes["default"].object,
  changeCurrentElement: _propTypes["default"].func,
  toggleElementPreview: _propTypes["default"].func,
  viewMode: _propTypes["default"].string,
  addElement: _propTypes["default"].func,
  moveElement: _propTypes["default"].func,
  moveElementToTrash: _propTypes["default"].func,
  moveElementFromTrash: _propTypes["default"].func,
  duplicateElement: _propTypes["default"].func,
  undoChanges: _propTypes["default"].func,
  redoChanges: _propTypes["default"].func,
  flowSettings: _propTypes["default"].object,
  allQuestionStartNumbers: _propTypes["default"].object,
  verifyAndImportElements: _propTypes["default"].func,
  dynamicUserLists: _propTypes["default"].array,
  dynamicUserListsValues: _propTypes["default"].object,
  defaultValues: _propTypes["default"].array
});
_defineProperty(FlowList, "defaultProps", {
  currentElement: {}
});